import { render, staticRenderFns } from "./ProblemStatistics.vue?vue&type=template&id=5b4cb361&scoped=true"
import script from "./ProblemStatistics.vue?vue&type=script&lang=js"
export * from "./ProblemStatistics.vue?vue&type=script&lang=js"
import style0 from "./ProblemStatistics.vue?vue&type=style&index=0&id=5b4cb361&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cb361",
  null
  
)

export default component.exports